<template>
  <div class="question" :class="{ 'man': data.sideImg }">
    <div class="text" v-if="titleText">{{ titleText }}</div>
    <div class="img" v-if="data.qImg">
      <img :src="'//cdn.original-fun.com/gugong/' + data.qImg + '.png'" />
    </div>
    <div class="answer-box" :class="{ 'man': data.sideImg }">
      <div
        class="a"
        :class="{ 'curr': index === selectedIndex }"
        v-for="(item, index) in data.answerArr"
        :key="index"
        v-html="item.txt"
        @click="choose(item, index)"
      ></div>
    </div>
    <div class="side-man" v-if="data.sideImg">
      <div class="inner-abs-box">
        <img
          class="img"
          :src="'//cdn.original-fun.com/gugong/' + data.sideImg + '.png'"
          :style="data.sideCfg"
        />
      </div>
    </div>
    <HeadTip
      :style="data.headTipStyle"
      :data="data"
      v-if="right === false"
      @jump="$emit('jump', false)"
    ></HeadTip>
  </div>
</template>

<script>
//script
import Tools from "../../scripts/tools";
import { gsap } from "gsap";
//Global
import Global from "../../scripts/Global";

//组件
import HeadTip from "./headTip";

export default {
  props: ["data"],
  data() {
    return {
      titleText: this.data.qText,
      selectedIndex: undefined,
      selectedData: undefined,
      right: undefined
    };
  },
  components: { HeadTip },
  created() {},
  computed: {},
  methods: {
    choose(item, index) {
      if (this.right === undefined || item.type === "reload") {
        this.selectedIndex = index;
        this.selectedData = item;

        this.right = !!this.selectedData.right;
        if (this.right) {
          this.$emit("jump", true);
        } else {
          this.titleText = this.data.errText;
        }

        this.$emit("finish", this.right);
      }
    },
    submit() {}
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.question {
  background-image: url(//cdn.original-fun.com/gugong/答题弹框.png);
  background-position: 0 90%;
  width: 7.5rem;
  height: 9rem;
  margin: 0 auto;
  background-repeat: no-repeat;
  position: relative;
  bottom: 0;
  background-size: contain;
  top: 50%;
  margin-top: -5rem;
  font-size: 12px;
  position: absolute;

  .img {
    width: 4rem;
    margin: 0.2rem auto 0 auto;
      transform-origin: center bottom;
    img {
      width: 100%;
    }
  }

  &.man {
    .text {
      width: 3.2rem;
      padding: 0.1rem 1rem 0.1rem 0.2rem;
    }
  }

  .text {
    width: 4rem;
    background: #ffffff54;
    margin: 2.2rem auto 0 auto;
    padding: 0.1rem 0.2rem 0.1rem 0.2rem;
    text-align: left;
    color: #6c5141;
    font-weight: bold;
  }

  .answer-box {
    width: 6rem;
    margin: 0 auto;
    padding: 20px 0 0 0px;
    position: relative;
    &.man {
      .a {
        width: 3.5rem;
        margin: 0 0 0.3rem 0.45rem;
      }
      .side-man {
        display: block;
      }
    }
    .a {
      background-image: url(//cdn.original-fun.com/gugong/答题未选中按钮.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      line-height: 1rem;
      margin-left: -2rem;
      margin-top: 0.1rem;
      text-align: center;
      color: #fff;
      width: 3.5rem;
      height: 1rem;
      margin: 0 auto 0.3rem auto;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      &.curr {
        background-image: url(//cdn.original-fun.com/gugong/答题选中按钮.png);
      }
    }
  }
  .side-man {
    position: absolute;
    width: 2rem;
    bottom: 0;
    right: 0.6rem;
    height: 10rem;
    .inner-abs-box {
      position: relative;
      width: 100%;
      height: 100%;
      text-align: center;
    }
    .img {
      position: absolute;
      bottom: 0px;
      left: 0;
    }
  }
}
</style>
